import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { selectTeamById } from "@overmap-ai/core"
import { getRouteApi, Link } from "@tanstack/react-router"
import { memo } from "react"

import { TeamIcon } from "../../components/Icons/TeamIcon"
import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/settings/teams/$teamId/members")

export const TeamSettingsMembersViewTopBar = memo(() => {
	const { teamId } = routeApi.useParams()
	const team = useAppSelector(selectTeamById(teamId))!

	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/teams/$teamId/members"
					to="/$organizationId/settings/teams/$teamId"
				>
					<Button>
						<LuIcon icon={modelIconMapping.arrowLeft} />
						<TeamIcon teamId={teamId} />
						<Text>{team.name}</Text>
					</Button>
				</Link>
			}
		/>
	)
})
TeamSettingsMembersViewTopBar.displayName = "TeamSettingsMembersViewTopBar"
